import { getOrganizationLogo } from "@/api";
import { useOrganization } from "@/contexts/frontend/organization/useOrganization";
import { useQuery } from "@tanstack/react-query";

export function OrganizationLogo() {
    const { organization } = useOrganization();

    const { data: logoUrl } = useQuery({
        queryKey: ["organizationLogo", organization.id],
        queryFn: () => getOrganizationLogo(organization.id),
    });

    if (!logoUrl?.signed_url) {
        return (
            <span className="text-foreground text-lg font-semibold">
                {organization.name}
            </span>
        );
    }

    return (
        <img
            src={logoUrl.signed_url}
            alt={organization.name}
            className="h-auto max-h-10 w-auto max-w-[120px] object-contain"
        />
    );
}
